module.exports = __webpack_public_path__ + "dist/assets/img/Y.a725d9de.svg";